import { render, staticRenderFns } from "./LoadShare.vue?vue&type=template&id=6ffdc266&scoped=true&"
import script from "./LoadShare.vue?vue&type=script&lang=js&"
export * from "./LoadShare.vue?vue&type=script&lang=js&"
import style0 from "./LoadShare.vue?vue&type=style&index=0&id=6ffdc266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffdc266",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VContainer,VFlex,VLayout,VProgressLinear,VTextField})
